import React, { useState } from "react";
import { loginUser } from "../../api/userApi";
import {Link, useNavigate} from "react-router-dom";
import logo from "../../assets/images/ume logo.PNG";

const Login = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const res = await loginUser(email, password);

            localStorage.setItem("userId", res.userId);
            navigate("/dashboard");
        } catch (error) {
            setError(error.response?.data?.message || "Login failed");
        }
    }

    return (
        <div className="font-montserrat">

            <div className="w-full bg-white flex">
                <Link to="/" className="landing-logo-link">
                    <img src={logo} alt="UME Health logo" className="landing-logo max-w-none m-2" />
                </Link>
                <h1 className="text-4xl text-[#04395B] font-extrabold pt-8">
                    Welcome to UME Health — Your comprehensive healthcare management tool.
                </h1>
            </div>

            <div className="flex justify-between items-center h-screen bg-[#B0E2BF]">

                <div className="flex w-full max-w-screen-xl">


                    <div className="flex items-center justify-center w-2/3 h-screen bg-white" style={{ backgroundImage: "url('/90d2.png')", backgroundRepeat: "no-repeat", }}>

                        <div className="w-full max-w-md p-6 ml-12 bg-white border border-gray-500 rounded-lg md:p-12">
                            <form className="w-full" onSubmit={handleLogin}>
                                <h3 className="mb-8 text-2xl font-extrabold lg:text-3xl">
                                    Sign in
                                </h3>

                                <div className="space-y-6">
                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-slate-800">Email</label>
                                        <input name="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full px-4 py-3 text-sm border rounded-md outline-none bg-slate-100 text-slate-800 focus:border-blue-600 focus:bg-transparent" placeholder="Enter Email" />
                                    </div>
                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-slate-800">Password</label>
                                        <input name="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full px-4 py-3 text-sm border rounded-md outline-none bg-slate-100 text-slate-800 focus:border-blue-600 focus:bg-transparent" placeholder="Enter Password" />
                                    </div>
                                    <div className="flex flex-wrap items-center justify-between gap-4">
                                        <div className="flex items-center">
                                            <input id="remember-me" name="remember-me" type="checkbox" className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500 border-slate-300" />
                                            <label htmlFor="remember-me" className="block ml-3 text-sm text-slate-500">
                                                Remember me
                                            </label>
                                        </div>
                                        <div className="text-sm">
                                            <a href="javascript:void(0);" className="font-medium text-blue-600 hover:text-blue-500">
                                                Forgot your password?
                                            </a>
                                        </div>
                                    </div>

                                    {error && <p className="text-red-500">{error}</p>}
                                </div>

                                <div className="!mt-12">
                                    <button type="submit" className="w-full shadow-xl py-2.5 px-4 text-sm font-semibold rounded text-white bg-[#04395B]">
                                        Sign In
                                    </button>
                                </div>

                                <div className="flex items-center gap-4 my-4">
                                    <hr className="w-full border-slate-300" />
                                    <p className="text-sm text-center text-slate-800">or</p>
                                    <hr className="w-full border-slate-300" />
                                </div>

                                <div className="flex justify-center space-x-6">
                                    <button type="button" className="border-none outline-none">
                                        {/* Google logo */}
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" viewBox="0 0 512 512">
                                            <path fill="#fbbd00" d="M120 256c0-25.367 6.989-49.13 19.131-69.477v-86.308H52.823C18.568 144.703 0 198.922 0 256s18.568 111.297 52.823 155.785h86.308v-86.308C126.989 305.13 120 281.367 120 256z" />
                                            <path fill="#0f9d58" d="m256 392-60 60 60 60c57.079 0 111.297-18.568 155.785-52.823v-86.216h-86.216C305.044 385.147 281.181 392 256 392z" />
                                            <path fill="#31aa52" d="m139.131 325.477-86.308 86.308a260.085 260.085 0 0 0 22.158 25.235C123.333 485.371 187.62 512 256 512V392c-49.624 0-93.117-26.72-116.869-66.523z" />
                                            <path fill="#3c79e6" d="M512 256a258.24 258.24 0 0 0-4.192-46.377l-2.251-12.299H256v120h121.452a135.385 135.385 0 0 1-51.884 55.638l86.216 86.216a260.085 260.085 0 0 0 25.235-22.158C485.371 388.667 512 324.38 512 256z" />
                                            <path fill="#cf2d48" d="m352.167 159.833 10.606 10.606 84.853-84.852-10.606-10.606C388.668 26.629 324.381 0 256 0l-60 60 60 60c36.326 0 70.479 14.146 96.167 39.833z" />
                                            <path fill="#eb4132" d="M256 120V0C187.62 0 123.333 26.629 74.98 74.98a259.849 259.849 0 0 0-22.158 25.235l86.308 86.308C162.883 146.72 206.376 120 256 120z" />
                                        </svg>
                                    </button>

                                    {/* facebook logo */}
                                    <button type="button" className="border-none outline-none">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-9 h-9" viewBox="0 0 48 48">
                                            <path fill="#039be5" d="M24 5A19 19 0 1 0 24 43A19 19 0 1 0 24 5Z"></path><path fill="#fff" d="M26.572,29.036h4.917l0.772-4.995h-5.69v-2.73c0-2.075,0.678-3.915,2.619-3.915h3.119v-4.359c-0.548-0.074-1.707-0.236-3.897-0.236c-4.573,0-7.254,2.415-7.254,7.917v3.323h-4.701v4.995h4.701v13.729C22.089,42.905,23.032,43,24,43c0.875,0,1.729-0.08,2.572-0.194V29.036z"></path>
                                        </svg>
                                    </button>

                                    {/* apple logo */}
                                    <button type="button" className="border-none outline-none">
                                        <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8" viewBox="0 0 50 50">
                                            <path d="M 44.527344 34.75 C 43.449219 37.144531 42.929688 38.214844 41.542969 40.328125 C 39.601563 43.28125 36.863281 46.96875 33.480469 46.992188 C 30.46875 47.019531 29.691406 45.027344 25.601563 45.0625 C 21.515625 45.082031 20.664063 47.03125 17.648438 47 C 14.261719 46.96875 11.671875 43.648438 9.730469 40.699219 C 4.300781 32.429688 3.726563 22.734375 7.082031 17.578125 C 9.457031 13.921875 13.210938 11.773438 16.738281 11.773438 C 20.332031 11.773438 22.589844 13.746094 25.558594 13.746094 C 28.441406 13.746094 30.195313 11.769531 34.351563 11.769531 C 37.492188 11.769531 40.8125 13.480469 43.1875 16.433594 C 35.421875 20.691406 36.683594 31.78125 44.527344 34.75 Z M 31.195313 8.46875 C 32.707031 6.527344 33.855469 3.789063 33.4375 1 C 30.972656 1.167969 28.089844 2.742188 26.40625 4.78125 C 24.878906 6.640625 23.613281 9.398438 24.105469 12.066406 C 26.796875 12.152344 29.582031 10.546875 31.195313 8.46875 Z"></path>
                                        </svg>
                                    </button>
                                </div>

                                <div className="mt-6 text-center">or sign in with biometrics</div>

                            </form>
                        </div>
                    </div>

                    <div className="lg:w-1/3 w-0 bg-[#B0E2BF]">
                        <div className="mt-64 text-center ml-60">
                            <h2 className="text-4xl overflow-visible font-extrabold text-[#04395B]">New User?</h2>
                            <p className="mt-4 text-lg text-slate-700">Register here!</p>
                            <a href="/registration">
                                <button type="button" className="mt-6 py-2 px-4 rounded bg-[#04395B] text-white font-semibold">
                                    Sign Up
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
